// src/pages/MexicoCityTour.jsx
import MissionTourApp from "../MissionTourApp";
import { MEXICO_CITY_TOUR } from "../data/tours/mexicoCityTourData";

export default function MexicoCityTour() {
  return <MissionTourApp tourData={MEXICO_CITY_TOUR} />;
}
